import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
export function SignOutButton({ label = "Sign out", className }: { label?: string; className?: string }) {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  return (
    <button type="button" className={className} onClick={() => { void signOut().then(() => navigate("/")); }}>
      {label}
    </button>
  );
}
